import React from 'react';

const BuyerRegionCharges = ({calculatedValues}) => {
  return (
    <>
      <div className='col-md-6 col-pl-20'>
                    <div className={`table-responsive res-cus-table ${calculatedValues  ? 'validated-table' : '' }`}>
                        <table className='cus-table'>
                            <thead className='table-header'>
                            <tr>
                                <th>Applicable Losses</th>
                                <th>%</th>
                                <th>In KW</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>ISTS Losses</td>
                                    <td>{(calculatedValues?.applicableLosses?.istsLoss[0] || 0)?.toFixed(2)} %</td>
                                    <td>{(calculatedValues?.applicableLosses?.istsLoss[1] || 0)?.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td>STU Losses - Seller</td>
                                    <td>{(calculatedValues?.applicableLosses?.stuLossSeller[0] || 0)?.toFixed(2)} %</td>
                                    <td>{(calculatedValues?.applicableLosses?.stuLossSeller[1] || 0)?.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td>Wheeling/Distribution Losses - Seller</td>
                                    <td>{(calculatedValues?.applicableLosses?.distributionLossSeller[0] || 0)?.toFixed(2)} %</td>
                                    <td>{(calculatedValues?.applicableLosses?.distributionLossSeller[1] || 0)?.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td>STU Losses - Buyer</td>
                                    <td>{(calculatedValues?.applicableLosses?.stuLossBuyer[0] || 0)?.toFixed(2)} %</td>
                                    <td>{(calculatedValues?.applicableLosses?.stuLossBuyer[1] || 0)?.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td>Wheeling/Distribution Losses - Buyer</td>
                                    <td>{(calculatedValues?.applicableLosses?.distributionLossBuyer[0] || 0)?.toFixed(2)} %</td>
                                    <td>{(calculatedValues?.applicableLosses?.distributionLossBuyer[1] || 0)?.toFixed(2)}</td>
                                </tr>   
                            </tbody>
                            <tfoot className='cus-table-ftr'>
                                <tr>
                                    <td>Total Power at Premises</td>
                                    <td></td>
                                    <td>{(calculatedValues?.applicableLosses?.totalPowerAtPremises || 0)?.toFixed(2)}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
    </>
  );
}

export default BuyerRegionCharges;
